export function applyOpacity(
  hexColor: string,
  opacityPercentage: number,
): string {
  if (opacityPercentage < 0 || opacityPercentage > 100) {
    throw new Error('The opacity percentage must be in the range [0, 100].');
  }

  const alpha = opacityPercentage / 100;
  const rgbColor = parseInt(hexColor.slice(1), 16);
  const r = (rgbColor >> 16) & 255;
  const g = (rgbColor >> 8) & 255;
  const b = rgbColor & 255;

  return `rgba(${r},${g},${b},${alpha})`;
}

export const generateColor = (letter: string) => {
  const colors = [
    '#aa2e25',
    '#a31545',
    '#9c27b0',
    '#673ab7',
    '#3f51b5',
    '#2196f3',
    '#03a9f4',
    '#00bcd4',
    '#357a38',
    '#00695f',
    '#009688',
    '#00a152',
    '#ff9800',
    '#b28900',
  ];
  const code = letter.charCodeAt(0);
  const index = code % colors.length;
  return colors[index];
};
